import { gql } from '@apollo/client';

export const GET_CREATABLE_BAG_BUSINESS_TYPES = gql`
    query GetCreatableBagBusinessTypes($warehouseId: Long!) {
        getCreatableBagBusinessTypes(warehouseId: $warehouseId)
    }
`;

export interface GetCreatableBagBusinessTypesResponse {
    // 后端返回可创建的包牌业务类型值列表：1=SwiftX, 2=TTSort, 3=TEMUSort
    getCreatableBagBusinessTypes: number[];
}
